module.exports = __webpack_public_path__ + "2ce3dd706b437783e54e689c9fcc490b.png";